import React from 'react';
import {
    View, ScrollView,StyleSheet,
    Animated,TouchableOpacity,Image,Button,
    Dimensions,Modal , ImageBackground,
    ActivityIndicator, SafeAreaView,Share,TouchableWithoutFeedback
} from 'react-native';
// import { WebView } from 'react-native-webview';
import { Surface } from 'react-native-paper';
// import { isIos, isIphoneX } from './../Utils';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from 'react-native-vector-icons/FontAwesome';
import { connect } from 'react-redux';
import Header from "./../../components/Header/index";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
// import AdsScreen from './../Ads';
import { 
        clearLibraryTopicsBySubjectData, 
        getLibraryTopicsBySubject, 
        getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark
        
     } from './../../store/action';
// import StylesColors from './../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';

// import OfflineHandler from './../OfflineHandler';
// import PaymentButtonComponent from './paymentButtonComponent';
import PaymentButtonComponent from "./../../components/paymentButton";

import { FOR_LIBRARY_CONTENT } from './../../store/constants';
// import ToasterComponent from './../snackBarComponent';
// import { subscriptionPlanPaymentStatus } from './../../store/selectors';
// import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';
import {Text, Styles, Config} from "./../../components/UI-Components"
import EmptyFullscreen from './../EmptyFullScreen';
import { MaterialAndTestSeriesComponent} from './../../components';


import { LIBRARY_MATERIAL, TOPIC_LIBRARY_SCREEN, CONTENT_LIBRARY_BOOKS } from './../../store/constants/bookmarkConstants';
import { bookmarksSelector } from './../../store/selectors';
import Lock from  '@material-ui/icons/Lock';
import NavigateNext from  '@material-ui/icons/NavigateNext';
import Description from  '@material-ui/icons/Description';
import Toaster from './../../components/snackBar_toaster';

// const { width, height } = Dimensions.get("window");
const width = 480;
const _width = window.innerWidth;


const emptySubjectScreen = require('./../../assets/emptyLibrary.png')
const videoIcon = require('./../../assets/assets_png/lessonVideo.png');
const pdfIcon = require('./../../assets/assets_png/Pdf.png');
const rightArrow = require('./../../assets/assets_png/rightArrow.png');
const lock = require('./../../assets/assets_png/lock.png');
const testIcon = require('./../../assets/assets_png/test.png');
const epubIcon = require('./../../assets/assets_png/epub.png');


const ContentCounterComponent = ({type, count, content}) => {
    return(
 
        <>      
         {
             content[type] && 
                <View style={styles.contentCountWrapper}>
                    <Image 
                      source={type === 'video' ?
                       videoIcon 
                       : type ==='pdf'?
                        pdfIcon : 
                        type ==='epub'
                        ?
                        pdfIcon
                        :
                        type === 'test'
                        ?
                        testIcon
                        :null

                    } 
                     style={styles.contentIcon}
                     />
                    <Text style={[styles.contentCount, {color: Styles.primaryColor}]}>{count} <Text style={{fontWeight: '600'}}>{` ${type === 'epub' ? 'material' : type} `}</Text></Text>
                    <Text style={{color: Styles.primaryColor}}>{count > 1 ? "'s" : ""}</Text>
                </View> 
         } 
        </>

    )
}


const LessonComponent = ({
    
    topicId, subjectId, history, title, price,
     subjectName, hasUserPaid, isFree, videoCount,
      pdfCount, showToaster,
      navigation,
      accessToLibrary, epubCount,
      addBookMarks, deleteBookMark, isBookmarked, item,
     bookmarkId}) => {

    const showAll = videoCount === 0 && pdfCount === 0 && epubCount === 0;
    const content = {
        video: showAll || videoCount > 0,
        pdf: showAll || pdfCount > 0,
        material: showAll || epubCount > 0 
    }

    return(
        
            <TouchableWithoutFeedback
              
                onPress={() =>{
                    if(videoCount < 1 && pdfCount < 1 && epubCount < 1) return typeof showToaster === 'function' ? showToaster('Will be Updated Soon', 2000) : null
                    navigation.push('/contentLibraryScreen', {
                    topicId,                                        
                    subjectId,
                    price,
                    subjectName,
                    hasUserPaid,
                    isFree,
                    title,
                    // accessToLibrary,
                    
                })
                }
                }
                // style={styles.topicWrapperTouchable}
            >
                   <View style={styles.lessonWrapper} >
            <View style={styles.lessonHeader}>
                    <View style={{flexDirection: 'row', justifyContent: 'space-between',
                      width: '100%',}}>
                      <View style={{width: '80%'}}>
                        <Text style={{...styles.headerText, marginRight: 10, fontWeight: '700' }}
                        elipsizeMode='tail'
                        numberOfLines={2}
                         >{title}</Text>
                      </View>
                     
                    </View>
                    <View style={styles.contentCounter}>            
                        <ContentCounterComponent type="video" count={videoCount} content={content} />                               
                        <ContentCounterComponent type="pdf" count={pdfCount}   content={content}/>                          
                        <ContentCounterComponent type="epub" count={epubCount}   content={content}/>                          
                                            
                    </View>
                </View>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                    {
                        !hasUserPaid || !isFree &&
                           <Image source={lock} size={18} style={{ marginHorizontal: 4}}/>   
                    }
                    <Image source={rightArrow} size={18} />
                </View>
            </View>
            </TouchableWithoutFeedback>
     
    )
}

class TopicsLibraryBooks extends React.Component{ 

    constructor(props){
        super(props);
        this.state={  
            toasterMessage: null,
            showToast: false,
            description: null         
        }
    }

 

    // static navigationOptions = ({navigation}) => {
    //     return {
    //         headerTitle: navigation.getParam('subjectName', 0) ||  "CHOOSE TOPICS" ,
    //         headerBackground: 
    //         ( <LinearGradientComponent />),
    //         headerTintColor:StylesColors.headerTintColor,
    //           headerTitleStyle: {
    //             color:StylesColors.headerTextColor,
    //             alignItems:'center',
    //             alignSelf: 'center',
    //             // width: '80%',
    //             textAlign: 'center',
    //             fontWeight:StylesColors.headerTextFontWeight,
    //             textTransform: 'uppercase'
    //          },
    //       }
    //     }

        componentDidMount() {
            const { state={}} = this.props.location || {}

            const { subjectId=null, price=0, subjectName='', hasUserPaid=0,isFree=0,subjectImageUrl  } = state || {}
         
            if(subjectId) {
                this.setState({                    
                    subjectId,
                    price,
                    subjectName,
                    hasUserPaid,
                    isFree,
                    subjectImageUrl
                    // accessToLibrary
                }, () => this.props.getLibraryTopicsBySubject(subjectId));
                
            }else {
                alert("please select valid subject");
            }
        } 
        
        componentDidUpdate(prevProps) {
            if(prevProps.topicsInfo !== this.props.topicsInfo){
                if(this.props.topicsInfo){
                   this.props.topicsInfo && this.props.topicsInfo.length > 0 && this.props.topicsInfo.map(item => {
                       this.setState({
                           topicName: item.library_topic_name,
                           subjectDetails: item.library_topic_subject
                       })
                   })
                    // if(description){
                    //     // this.props.navigation.setParams({
                    //     //      description: description,
                    //     //      title: course_name
                    //     //     })
                    // }
                }
            }
            // if(prevProps.response !== this.props.response) {
            //     if(this.props.response) {
            //         // const message = this.props.response.data && this.props.response.data.message || 'Successfully payment is done';
            //         // this.showToaster(message, 2000);
            //         // this.props.getHomeInfo();
            //         // this.props.getLibrarySubjects();
            //         // setTimeout(() => {
            //         //     this.props.navigation.navigate('Library');
            //         // }, 2000);
            //     }
            // }
    
            // if(prevProps.paymentError !== this.props.paymentError) {
             
            //     if(this.props.paymentError) {
                   
            //       setTimeout(() => { 
            //         const errorInfo = this.props.paymentErrorMessage || 'failed..'

            //         this.showToaster(errorInfo, 2000)
            //       }, 300);
            //     }
            // }
            if(prevProps.addBookMarkResponse !== this.props.addBookMarkResponse) {     
                if(this.props.addBookMarkResponse) {
                  this.props.getBookMarks();
                }
              }
        }

        // showToaster = (msg='', time=1000) => this.refs.toast.show(msg, time)

        componentWillUnmount() {
            this.props.clearLibraryTopicsBySubjectData();
        }

        showToaster = (msg, time=1000) => {
            this.setState({
              showToast: true,
              toasterMessage: msg
            })
          }
          handleClose = () => {
            this.setState({
                showToast: false,
                toasterMessage: null
              })
        }
        fetchTopicsInfo = () => {
            const {topicsInfo} = this.props;
            if(topicsInfo && topicsInfo.length) return null; 
            const subjectId = this.props.navigation.getParam('subjectId', null);    
            if(subjectId) { 
                this.setState({                    
                    subjectId
                })               
                this.props.getLibraryTopicsBySubject(subjectId);
            }
        }
        makePayment = () => {        
            const {subjectId, price} = this.state;  
            // console.log(subjectId);  
            setTimeout(() => {
                this.props.navigation.navigate('PaymentScreen', {
                    paymentInfo: {                                            
                        transactionType: FOR_LIBRARY_CONTENT,
                        price,
                        subjectId
                    }
                })
            }, 200);
        }
        
        addBookMark = (item) => {   
            const meta  = {
                subjectId: this.state.subjectId,
                topicId: item?.id
            }

            const data = {
                content_id: item && item.id,
                content_name: 'titleId',
                content_url: "null",
                screen_name: CONTENT_LIBRARY_BOOKS,
                type: LIBRARY_MATERIAL,
                image_url: '',
                description: null,
                title: item && item.library_topic_name,
                meta_data: JSON.stringify(meta),
            }
            this.props.addBookMark(data)
            
        }

        librarySubjectPayment = () => {
            const {subjectId, price} = this.state    
            // console.log(subjectId);  
            setTimeout(() => {
                this.props.history.push('Payment', {
                    paymentInfo: {                                            
                        transactionType: FOR_LIBRARY_CONTENT,
                        price,
                        subjectId
                    }
                })
            }, 200);  
            // this.props.checkoutCreateTest(null, price, null, FOR_LIBRARY_CONTENT, subjectId);
        }
 
    render() {     
        const { subjectId, price, subjectName, hasUserPaid, isFree, topicName,
            subjectDetails   } = this.state;
        const {topicsInfo } = this.props;
        const { actual_price, is_discounted, discount_price, library_subject_image,  library_subject_name, } = subjectDetails || {};
      
        return (
            <>
             <Header
                title="Topics "
                headerRight
                
                headerRightClick={() => this.props.history.push('/Home')}
                headerLeftClick={() => this.props.history.goBack()}
                backButton={true}
            // headerRightClick={() => alert()}
            />
            <Container maxWidth='lg'>
            <div 
             className='conditions'
             style={{marginTop: 10, }}
            >
                {/* <BackHandlerAndroid goBack={true} />
                <OfflineHandler callBack = {this.fetchTopicsInfo} /> */}
                {
                   this.props.loading && <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', borderColor: '#fff'}}>
                        <LoadingComponent styles={{width: 250, height: 250}}/>
                       </View>
                }

                {
                   this.props.error && <View style={{height: '100%', width: '100%'}}>{ typeof this.props.errorInfo === 'string' ? <EmptyFullscreen
                    images={emptySubjectScreen}
                    title={this.props.errorInfo}
                   />
                        
                     : <EmptyFullscreen
                     images={emptySubjectScreen}
                     title={'something went wrong...'}
                    />  }</View>
                }

             <View style={{width: '100%', height: '100%'}}>

             
              <ScrollView style={{ paddingBottom: 60, paddingHorizontal: 12, flex: 1, backgroundColor: Styles.fiveMantraBgColor}}>
              <View>
                        {
                             topicsInfo && topicsInfo.length > 0 &&
                        <>
                        <MaterialAndTestSeriesComponent
                          imageUrl={library_subject_image}
                          courseName={topicName}
                        //   duration={duration}
                        //   ratings={admin_rating}
                          isUserPaid={hasUserPaid}
                          isFree={isFree}
                          discounted={is_discounted}
                          actualPrice={actual_price}
                          discountPrice={discount_price}
                          examName={library_subject_name}
                          isLibrary={true}
                            makePayment={this.makePayment}

                        />
                        
                        <View style={{marginTop: 10}}>
                          <View style={{flex:1, marginHorizontal: 12}}>
                             <Text style={{fontSize: 20, fontWeight: '700', marginBottom: 15}}>Materials</Text>
                          </View>
                        </View>
                        <View style={{ paddingBottom: 20, marginBottom: 25, flexDirection:  _width <=780  ? 'column' : 'row',
                         justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'}}>
                        {
                            topicsInfo && topicsInfo.length > 0 && topicsInfo.map((topics, index) => {
                                console.log(topics);
                                const {
                                   
                                    content_e_pub_count,
                                    content_pdf_count,
                                    content_videos_count,
                                    library_topic_name,
                                    id
                                } = topics;
                                const title = library_topic_name;
                                const pdfCount = content_pdf_count
                                const videoCount = content_videos_count;
                                const epubCount = content_e_pub_count;
                                return(
                                   
                                    <LessonComponent
                                        videoCount={videoCount}
                                        pdfCount={pdfCount}
                                        epubCount={epubCount}
                                        title={title}
                                        isUserPaid={hasUserPaid}
                                        isFree={isFree}
                                        navigation={this.props.history} 
                                        key={index}
                                        topicId={id}
                                        lesson={topics}
                                        subjectName={subjectName}
                                        subjectId={subjectId}
                                        price={price} 
                                        showToaster={this.showToaster}

                                      
                                        />
                                )
                            })
                        }
                        </View>
                     </>
                    }
                    </View>
            
                  
                    </ScrollView>
            
         {/* {
              Config.librarySubjectPayment && this.props.topicsInfo &&  this.props.topicsInfo.length > 0 &&
                <PaymentButtonComponent 
                    price={price} 
                    subjectName={subjectName} 
                    onPress={this.librarySubjectPayment}
                    hasUserPaid={!hasUserPaid}
                />
            } */}
            </View>
            <Toaster 
                  show={this.state.showToast}
                  message={this.state.toasterMessage}
                  handleClose={this.handleClose}
                duration={1500}
                />
         </div>
         </Container>
         </>
        )
    }
}
const styles = StyleSheet.create({
    mainImageView:{
        height:180,
        width:Math.floor(width/2-20),
        marginHorizontal:10,
        marginBottom: 16, 
        elevation: 8,
        marginTop:15,
    },
    ImageView:{
        flex:1, 
    },
    container: {
        flex: 1,
        borderWidth:1,
    },
    closeBtn:{
        fontWeight:'800',
        position:'absolute',
        top:50,
        right:15,
        zIndex:99999,
        fontSize:24,
        color:'#fff',
        alignItems:'center',
    },   
    topicWrapper: {
        // elevation: 4,
        // borderRadius:8,
        // marginVertical: 10,
        // marginHorizontal: 2,
        // height:hp(11)
        flexDirection: 'row',
        cursor: 'pointer',
        paddingHorizontal: 12, 
        paddingVertical: 16,
        justifyContent: 'space-between',
        alignItems: 'center',
        elevation: 8,
        borderRadius: 6,
        marginBottom: 12,
    },
    topicWrapperTouchable: {
        paddingBottom:8,
        paddingTop: 4,
        paddingHorizontal:10,
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        
    },
    topicDetails: { 
        flex: 1,
        // height:50,

    },
    contentTypeCountIndicator: {
        flexDirection: 'row',
        marginTop: 20,
        paddingLeft: 4,
    },
    contentTypeWrapper: {
        flexDirection: 'row',
        marginRight: 12,
        justifyContent: 'center',
        alignItems:'center'  
    },
    contentCount: {
        // color: '#B8C0C9',
        color:'rgba(0,0,0,0.7)',
        fontSize: 14,
        marginLeft: 4,
       
    },
    topicTile: {
        color: '#404B63',
        fontSize: 18,
        // marginBottom: 12,
        fontWeight: '600',
        marginRight: 5
    },
    contentImage: {
        height: 9,
        width: 7
    },
    lessonWrapper: {
        width: _width <= 780 ? '100%' : '48%',
        flexDirection: 'row',
        paddingHorizontal: 12, 
        paddingVertical: 12,
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 10,
        marginBottom: 12,
        borderWidth: 3,
        marginHorizontal: 10,
        borderColor: '#fff',
      
    },
    lessonHeader: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flex: 1,
        
    },
    headerText: {
        fontSize: 16,
        fontWeight: '500',
        color: 'rgba(0,0,0,0.7)'
    },
    contentCountWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 8,
        // marginTop: 2
        paddingVertical: 4,
    },
    contentIcon: {
        marginRight: 6,
        width: 16, 
        height: 16
    },
    contentCount: {
        fontSize: 14,
        color: 'rgba(0,0,0,0.75)',
        textTransform: 'capitalize',
        fontWeight: '600'

        
    },
    contentCounter: {
        flexDirection: 'row',
        justifyContent:'flex-start',
        alignItems: 'center',
        flex: 1,
        // borderWidth: 1,
        paddingTop: 10,
        // paddingBottom: 6,
        alignSelf: 'flex-start',
        // marginTop: 6,
        flexWrap: 'wrap'
    },
})

const mapStateToProps = state => { 
    // const paymentStatus = subscriptionPlanPaymentStatus(state);
    // const {
    //     error: paymentError,
    //     errorInfo: paymentErrorMessage,
    //     loading: paymentLoading,
    //     response,
    // } = paymentStatus;
    const bookmarkInfo = bookmarksSelector(state.allBookMarks);
    const addBookMarkResponse =  state?.addBookMark?.response?.bookmark;
    const deleteBookMarkInfo = state?.deleteBookMark?.response?.status === 'Success';
    const addBookMarkLoading = state?.addBookMark?.loading;

    return {
        topicsInfo: state.libraryTopicsBySubject && state.libraryTopicsBySubject.response && state.libraryTopicsBySubject.response.library_topics,
        loading: state.libraryTopicsBySubject && state.libraryTopicsBySubject.loading,
        error: state.libraryTopicsBySubject && state.libraryTopicsBySubject.error,
        errorInfo: state.libraryTopicsBySubject && state.libraryTopicsBySubject.errInfo && state.libraryTopicsBySubject.errInfo.data && state.libraryTopicsBySubject.errInfo.data.message,
        // paymentError,
        // paymentErrorMessage,
        // paymentLoading,
        // response,
        bookmarkInfo,
        addBookMarkResponse,
        deleteBookMarkInfo,
        addBookMarkLoading,
        libraryTopics: bookmarkInfo?.libraryTopics,
    }
}

export default connect(mapStateToProps, {
    clearLibraryTopicsBySubjectData, getLibraryTopicsBySubject, 
    getBookMarks , addBookMark, clearAddBookMarkData, deleteBookMark
   
    
})(TopicsLibraryBooks);